exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.underline-text-decoration[data-v-452bfb8e] {\n    text-decoration: underline;\n    text-decoration-thickness: 0.05em;\n}\n.no-text-decoration[data-v-452bfb8e] {\n    text-decoration: none;\n}\n\n", ""]);
